import ChangePasswordPage from "./ChangePasswordPage";

export default ChangePasswordPage;

export * from "./ChangePasswordPage";
